import { StatToColor, TypeToColor } from './consts.js';
import { AddImgTooltipEvents, AddTextTooltipEvents, WaitFetch, abilitiesJSON } from './helper.js';

$(window).on("load", async function () {
	await WaitFetch();

	CreateAbilitiesGrids();

	ColorKeywords();
});

function CreateAbilitiesGrids() {
	let $append: Array<Array<JQuery>> = [[], [], [], [], [], []];

	let prevAbility = "";
	let sectionIdx = 0;

	$append.forEach(subArr => {
		let $nameTitle = $(`<div>`, { class: "name topLeft" }).append($(`<h3>`, { text: "Ability" }));
		let $descTitle = $(`<div>`, { class: "desc" }).append($(`<h3>`, { text: "Description" }));
		let $changesTitle = $(`<div>`, { class: "changes topRight" }).append($(`<h3>`, { text: "Changes" }));

		subArr.push($nameTitle);
		subArr.push($descTitle);
		subArr.push($changesTitle);
	});

	Object.entries(abilitiesJSON!).forEach(([ability, abilityInfo], idx) => {
		let $name = $(`<div>`, { class: "name" }).append($(`<p>`, { text: ability }));
		let $desc = $(`<div>`, { class: "desc" }).append($(`<p>`, { text: abilityInfo.Description }));
		let $changes = $(`<div>`, { class: "changes" }).append($("<p>", { html: abilityInfo.Changes }));
		// let $desc = $(`<div>`, { class: "desc" }).append($(`<p>`, { html: abilityInfo.Description.replaceAll("\n", "<br>") }));
		// let $changes = $(`<div>`, { class: "changes" }).append($("<p>", { html: abilityInfo.Changes.replaceAll("\n", "<br>") }));

		if (abilityInfo.HoverInfo) {
			$changes.addClass("hoverInfo");
			$changes.data("abilityName", ability);
		}

		if (ability == "Color Change")
			$changes.addClass("colorChange");

		// -1 if key before prev, 1 if prev before key
		if (prevAbility && ability.localeCompare(prevAbility) < 0) {
			sectionIdx++;
		}
		else if ((idx + 1 < Object.keys(abilitiesJSON!).length && ability.localeCompare(Object.keys(abilitiesJSON!)[idx + 1]) > 0) ||
						 idx == Object.keys(abilitiesJSON!).length - 1) {
			$name.addClass("botLeft");
			// $desc.addClass("lastRow");
			$changes.addClass("botRight");
		}

		$append[sectionIdx].push($name);
		$append[sectionIdx].push($desc);
		$append[sectionIdx].push($changes);

		prevAbility = ability;
	});

	$append.forEach((subArr, idx) => {
		$(".sectionGrid").eq(idx).append(subArr);
	});

	AddTextTooltipEvents($(".hoverInfo"), ($ability: JQuery<HTMLDivElement>) => abilitiesJSON![$ability.data("abilityName")].HoverInfo, 350);
	AddImgTooltipEvents($(".colorChange"), "/images/abilities/ColorChangeChart-1.webp");
}

function ColorKeywords() {
	let colorRanges: Record<string, Array<Range>> = {
		Number: [],
		Normal: [],
		Fire: [],
		Water: [],
		Electric: [],
		Grass: [],
		Ice: [],
		Fighting: [],
		Poison: [],
		Ground: [],
		Flying: [],
		Psychic: [],
		Bug: [],
		Rock: [],
		Ghost: [],
		Dragon: [],
		Steel: [],
		Dark: [],
		Fairy: [],
		HP: [],
		Atk: [],
		Def: [],
		SpA: [],
		SpD: [],
		Spe: [],
	};

	$(".desc p, .changes p").each((_, el) => {
		const textNodes = Array.from(el.childNodes).filter(node => node.nodeType == Node.TEXT_NODE);
		
		textNodes.forEach(node => {
			let text = node.textContent!;

			Object.keys(colorRanges).forEach(keyword => {
				let searchTerms = [keyword];

				if (keyword == "Dark") {
					searchTerms.push("sleep");
					searchTerms.push("asleep");
					searchTerms.push("Yawn");
					searchTerms.push("Twilight Terrain");
				}
				else if (keyword == "Electric") {
					searchTerms.push("paralyze");
					searchTerms.push("Paralyze");
					searchTerms.push("paralysis");
					searchTerms.push("Electric Terrain");
				}
				else if (keyword == "Fairy") {
					searchTerms.push("Misty Terrain");
				}
				else if (keyword == "Fire") {
					searchTerms.push("burn");
					searchTerms.push("harsh sunlight");
					searchTerms.push("Sunny Day");
					searchTerms.push("Drought");
				}
				else if (keyword == "Grass") {
					searchTerms.push("Leech Seed");
					searchTerms.push("Ingrain");
					searchTerms.push("powder");
					searchTerms.push("spore");
					searchTerms.push("Grassy Terrain");
				}
				else if (keyword == "Ice") {
					searchTerms.push("hail");
				}
				else if (keyword == "Normal") {
					searchTerms.push("flinch");
				}
				else if (keyword == "Poison") {
					searchTerms.push("poison");
					searchTerms.push("badly poisoned")
				}
				else if (keyword == "Psychic") {
					searchTerms.push("fatigue");
					searchTerms.push("Fatigue");
					searchTerms.push("confus");
					searchTerms.push("Reflect");
					searchTerms.push("Light Screen");
					searchTerms.push("Trick Room");
					searchTerms.push("Psychic Terrain");
				}
				else if (keyword == "Rock") {
					searchTerms.push("sandstorm");
					searchTerms.push("Sandstorm");
					searchTerms.push("Sand Stream");
				}
				else if (keyword == "Water") {
					searchTerms.push("rain");
					searchTerms.push("Rain Dance");
					searchTerms.push("Drizzle");
					searchTerms.push("Aqua Ring");
				}

				else if (keyword == "Atk")
					searchTerms.push("Attack");
				else if (keyword == "Def")
					searchTerms.push("Defense");
				else if (keyword == "SpA")
					searchTerms.push("Special Attack");
				else if (keyword == "SpD")
					searchTerms.push("Special Defense");

				searchTerms.forEach(term => {
					let regex, match;
					if (term == "Number")
						regex = new RegExp(/[+-]?\d+(?:\.\d+)?(?:\s*→\s*)?\d*(?:\.\d+)?[%x]?/, "g");
					else
						regex = new RegExp(`\\b${term}[edingo]*\\b`, "g");

					while ((match = regex.exec(text)) != null) {
						let range = new Range();
						range.setStart(node, match.index);
						range.setEnd(node, match.index + match[0].length);

						colorRanges[keyword].push(range);

						if (match.index == regex.lastIndex)
							regex.lastIndex++;
					}
				});
			});
		});
	});

	Object.entries(colorRanges).forEach(([keyword, rangeList]) => {
		CSS.highlights.set(keyword, new Highlight(...rangeList));
	});
}